import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import AuthShell from "@/pages/auth/AuthShell";
import api from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); return; }
    api.post(`/auth/verify-email?token=${token}`).then(() => setState("ok")).catch(() => setState("error"));
  }, [params]);

  return (
    <AuthShell title="Email Verification" footer={<Link to="/dashboard" className="text-amber-400 font-semibold">Go to Dashboard</Link>}>
      <div className="text-center py-6" data-testid="verify-result">
        {state === "loading" && <Loader2 className="animate-spin text-amber-400 mx-auto" size={40} />}
        {state === "ok" && <><CheckCircle2 className="text-emerald-400 mx-auto" size={48} /><p className="text-slate-300 mt-4">Your email has been verified successfully.</p></>}
        {state === "error" && <><XCircle className="text-red-400 mx-auto" size={48} /><p className="text-slate-300 mt-4">This verification link is invalid or has expired.</p></>}
      </div>
    </AuthShell>
  );
}
